export var getIntials = function (firstName, lastName) {
    return firstName[0].toUpperCase() + lastName[0].toUpperCase();
};
export var getIntialsForCustomerLogo = function (customerName) {
    if (!customerName) {
        return '';
    }
    var words = customerName.trim().split(' ');
    if (words.length === 1) {
        return words[0].substring(0, 2).toUpperCase();
    }
    else {
        return (words[0][0] + words[1][0]).toUpperCase();
    }
};
